import { lazy } from 'react';
import { TopCars } from 'Containers/FMM';

const Cards = lazy(() => import(/* webpackChunkName: 'Cards' */ 'Components/Cards'));
const Consumption = lazy(
  () => import(/* webpackChunkName: 'Consumption' */ 'Components/Consumption')
);
const CustomerAlliance = lazy(
  () => import(/* webpackChunkName: 'CustomerAlliance' */ 'Components/CustomerAlliance')
);
const DealerPrivacy = lazy(
  () => import(/* webpackChunkName: 'DealerPrivacy' */ 'Plugins/DealerPrivacy')
);
const DealerImprint = lazy(
  () => import(/* webpackChunkName: 'DealerImprint' */ 'Plugins/DealerImprint')
);
const Imprint = lazy(() => import(/* webpackChunkName: 'Imprint' */ 'Plugins/Imprint'));
const HeroHeaderCompact = lazy(
  () => import(/* webpackChunkName: 'HeroHeaderCompact' */ 'Components/HeroHeader/compact')
);
const HeroHeaderSmall = lazy(
  () => import(/* webpackChunkName: 'HeroHeaderSmall' */ 'Components/HeroHeader/small')
);
const MoodImage = lazy(() => import(/* webpackChunkName: 'MoodImage' */ 'Components/MoodImage'));
const IntroText = lazy(() => import(/* webpackChunkName: 'IntroText' */ 'Components/IntroText'));
const Teaser = lazy(() => import(/* webpackChunkName: 'Teaser' */ 'Components/Teaser'));
const ContentTextDeprecated = lazy(
  () => import(/* webpackChunkName: 'ContentTextDeprecated' */ 'Components/ContentText/deprecated')
);
const ContentText = lazy(
  () => import(/* webpackChunkName: 'ContentText' */ 'Components/ContentText')
);
const BusinessOfferList = lazy(
  () => import(/* webpackChunkName: 'OfferList' */ 'Plugins/OfferList')
);
const ServiceOfferList = lazy(
  () => import(/* webpackChunkName: 'OfferList' */ 'Plugins/OfferList/service')
);
const Footnotes = lazy(() => import(/* webpackChunkName: 'Footnotes' */ 'Plugins/Footnotes'));
const CookieSettings = lazy(
  () => import(/* webpackChunkName: 'CookieSettings' */ 'Plugins/CookieSettings')
);
const Landingpage = lazy(() => import(/* webpackChunkName: 'Landingpage' */ 'Plugins/Landingpage'));
const DealerToolboxDetails = lazy(
  () => import(/* webpackChunkName: 'DealerToolboxDetails' */ 'Plugins/DealerToolboxDetails')
);
const LinkSection = lazy(
  () => import(/* webpackChunkName: 'LinkSection' */ 'Components/LinkSection')
);
const LinkSectionLink = lazy(
  () => import(/* webpackChunkName: 'LinkSectionLink' */ 'Components/LinkSection/link')
);
const IframeSource = lazy(
  () => import(/* webpackChunkName: 'IframeSource' */ 'Components/IframeSource')
);
const TeamList = lazy(() => import(/* webpackChunkName: 'TeamList' */ 'Plugins/TeamList'));
const GridContentBox = lazy(
  () => import(/* webpackChunkName: 'GridContentBox' */ 'Components/GridContentBox')
);
const CareerDetails = lazy(
  () => import(/* webpackChunkName: 'CareerDetails' */ 'Plugins/CareerDetails')
);
const CareerJobList = lazy(
  () => import(/* webpackChunkName: 'CareerJobList' */ 'Plugins/CareerJobList')
);
const Gallery = lazy(() => import(/* webpackChunkName: 'Gallery' */ 'Components/Gallery'));

const ChessboardRenderer = lazy(
  () => import(/* webpackChunkName: 'ChessboardRenderer' */ 'Components/Chessboard/renderer')
);
const ChessboardItem = lazy(
  () => import(/* webpackChunkName: 'ChessboardItem' */ 'Components/Chessboard/item')
);
const Video = lazy(() => import(/* webpackChunkName: 'Video' */ 'Components/Video'));
const ServiceDetails = lazy(
  () => import(/* webpackChunkName: 'ServiceDetails' */ 'Plugins/ServiceDetails')
);
const ServiceCategoryList = lazy(
  () => import(/* webpackChunkName: 'ServiceCategoryList' */ 'Plugins/ServiceCategoryList')
);
const AccessoriesList = lazy(
  () => import(/* webpackChunkName: 'AccessoriesList' */ 'Plugins/AccessoriesList')
);
const AccessoriesDetails = lazy(
  () => import(/* webpackChunkName: 'AccessoriesDetails' */ 'Plugins/AccessoriesDetails')
);
const AboutUs = lazy(() => import(/* webpackChunkName: 'AboutUs' */ 'Plugins/AboutUs'));
const LinkBox = lazy(() => import(/* webpackChunkName: 'LinkBox' */ 'Components/LinkBox'));
const Bentobox = lazy(() => import(/* webpackChunkName: 'Bentobox' */ 'Components/Bentobox'));
const LeadForm = lazy(() => import(/* webpackChunkName: 'LeadForm' */ 'Components/LeadForm'));
const Distance = lazy(() => import(/* webpackChunkName: 'Distance' */ 'Components/Distance'));

export const GENERIC_COMPONENT_MAP = {
  mask_bentobox: Bentobox,
  mask_chessboard_wcag: ChessboardRenderer,
  mask_chessboard_item_wcag: ChessboardItem,
  mask_consumption_info: Consumption,
  mask_customer_alliance: CustomerAlliance,
  mask_hero_header_big: HeroHeaderCompact,
  mask_hero_header_compact_wcag: HeroHeaderCompact,
  mask_hero_header_small_wcag: HeroHeaderSmall,
  mask_mood_image: MoodImage,
  mask_intro_text_wcag: IntroText,
  mask_contentbox_3columns_wcag: GridContentBox,
  mask_link_section_wcag: LinkSection,
  mask_link_section_item_wcag: LinkSectionLink,
  mask_video: Video,
  mask_json: IframeSource,
  mask_gallery: Gallery,
  mask_teaser_area_content: Teaser,
  mask_content_text: ContentTextDeprecated,
  mask_content_text_wcag: ContentText,
  mask_content_pagelinks_wcag: LinkBox,
  mask_leadform: LeadForm,
  mask_distance: Distance,
  plugin_mazdaapi_services_list: ServiceCategoryList,
  plugin_mazdaapi_services_detail: ServiceDetails,
  plugin_mazdaapi_career_job_list: CareerJobList,
  plugin_mazdaapi_career_job_detail: CareerDetails,
  plugin_mazdaapi_team_list: TeamList,
  plugin_mazdaapi_accessories_list: AccessoriesList,
  plugin_mazdaapi_accessories_detail: AccessoriesDetails,
  plugin_mazdaapi_aboutus: AboutUs,
  plugin_footnotes: Footnotes,
  plugin_footnotes_landingpage: Footnotes,
  plugin_mazdaapi_imprint: Imprint,
  plugin_mazdaapi_cookies: CookieSettings,
  plugin_mazdaapi_dealer_privacy: DealerPrivacy,
  plugin_mazdaapi_dealer_imprint: DealerImprint,
  mask_landingpage_business_offers: Landingpage,
  mask_landingpage_business_offers_highlight_offers: BusinessOfferList, // Vertriebsangebote
  mask_landingpage_service_offers: Landingpage,
  mask_landingpage_service_offers_highlight_offers: ServiceOfferList, // Elite Serviceangebote
  plugin_mazdaapi_dealertoolbox_detail: DealerToolboxDetails,
  mask_plugin_entrypage_subsites: Cards,
  mask_plugin_entrypage_showroom: Cards,
  mask_plugin_entrypage_services: Cards,
  mask_plugin_fmm_topcars: TopCars,
};

export const GENERIC_TYPES_TO_WRAP = {
  mask_link_section_item: 'mask_link_section',
  mask_link_section_item_wcag: 'mask_link_section_wcag',
  mask_chessboard_item: 'mask_chessboard',
  mask_chessboard_item_wcag: 'mask_chessboard_wcag',
};
